import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Admin from './admin';
import AdminData from './AdminData';

const path = window.location.pathname.replace(/\/$/, '');
const urlParams = new URLSearchParams(window.location.search);
const isViewAdmin = urlParams.get('view') === 'admin';

let Component;
if (path === '/admin/data') {
  Component = AdminData;
} else if (path === '/admin' || isViewAdmin) {
  Component = Admin;
} else {
  Component = App;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Component />
  </React.StrictMode>
);
